import { useEffect, useState } from "react";
import { Copy, Users, UserCheck, ArrowDownToLine, X } from "lucide-react";
import Rbg from "../../assets/rbg.png";
import BottomNavbar from "../../components/navs/mobilenav";
import { useUserContext } from "../../context/userContext";
// import { useNavigate } from "react-router-dom";
// import api from "../../utils/axiosConfig";
import toast from "react-hot-toast";

export default function ReferralDashboard() {
  const [showModal, setShowModal] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  // const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserContext();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (user?.user?.plan === "Free") {
  //     navigate("/account/home");
  //   }
  // }, [navigate, user?.user?.plan]);

  useEffect(() => {
    // Payment/Subscription-related referral payout flows are disabled.
    setReferralCode("");
  }, [])

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(referralCode);
    toast.success("Referral code copied to clipboard");
  }

  const BASEURL = "https://www.tweezers.app"

  const handleCopyLink = () => {
    navigator.clipboard.writeText(`${BASEURL}/auth/signup?referral=${referralCode}`);
    toast.success("Referral link copied to clipboard");
  }

  const handleWithdrawal = async () => {
    toast.error("Withdrawal is currently disabled");
    setShowModal(false);
  }

  return (
    <div>
      <div className="min-h-screen bg-white p-3 md:p-12 font-sans">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-violet-600 font-medium">
                Your Referral Dashboard
              </p>
              <h1 className="text-xl md:text-3xl font-medium md:font-bold">
                {user?.user?.name.split(" ")[0]}
              </h1>
            </div>
            <img
              src={`https://api.dicebear.com/7.x/identicon/svg?seed=${user?.user?.name}`}
              alt="avatar"
              className="w-9 h-9 rounded-full"
            />
          </div>

          {/* Earnings Card */}
          <div
            className="text-white p-6 rounded-2xl relative overflow-hidden bg-[#2C0053] bottom-2"
            style={{
              backgroundImage: `url(${Rbg})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
            }}
          >
            <p className="text-sm opacity-70">Total Referral Earnings</p>
            <h2 className="text-2xl md:text-4xl font-bold mt-2">
              ₦ {user?.user?.referralEarnings?.toLocaleString() || 0}
            </h2>
            <button
              onClick={() => setShowModal(true)}
              className="mt-6 flex items-center gap-2 bg-green-400 text-black px-6 py-2 rounded-xl text-sm font-medium"
            >
              <ArrowDownToLine size={18} /> Withdraw (Disabled)
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-4 md:gap-8 relative bottom-4">
            <div className="p-6 border border-gray-200 rounded-xl text-center">
              <Users className="mx-auto mb-2 text-gray-700" size={20} />
              <p className="text-gray-500 text-sm">Referrals</p>
              <p className="text-2xl font-bold">
                {user?.user?.referrals?.length || 0}
              </p>
            </div>
            <div className="p-6 border border-gray-200 rounded-xl text-center">
              <UserCheck className="mx-auto mb-2 text-gray-700" size={20} />
              <p className="text-gray-500 text-sm">Subscribed</p>
              <p className="text-2xl font-bold">
                {user?.user?.subscribed?.length || 0}
              </p>
            </div>
          </div>

          {/* Referral Code */}
          <div className="bg-black text-white p-6 rounded-xl flex flex-col md:flex-row md:items-center md:justify-between gap-4 relative bottom-6">
            <div>
              <p className="text-sm text-gray-400">Share Your Referral code:</p>
              <div className="flex items-center gap-2 mt-1">
                <p className="text-xl font-bold tracking-wide">
                  {referralCode}
                </p>
                <Copy 
                  className="w-4 h-4 cursor-pointer" 
                  onClick={handleCopyToClipboard}
                />
              </div>
            </div>
            <button 
              className="bg-green-400 text-black px-6 py-2 rounded-xl font-medium flex items-center gap-2"
              onClick={handleCopyLink}
            >
              Copy Link <Copy size={16} />
            </button>
          </div>

          {/* Referred Users */}
          <div className="relative bottom-6">
            <h2 className="text-base font-semibold mb-4">Your Referred Users</h2>
            <div className="max-h-80 overflow-y-scroll space-y-3 pr-2">
              {user?.user?.subscribed?.map((user, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 border border-gray-200 rounded-xl bg-white"
                >
                  <img
                    src={`https://api.dicebear.com/7.x/identicon/svg?seed=${user.name.split(" ")[0]}`}
                    alt="avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <div className="flex-1">
                    <p className="font-medium">{user.name}</p>
                    <p className="text-sm text-gray-500">Joined: {user.createdAt.split("T")[0]}</p>
                  </div>
                  <span className="text-green-600 font-medium flex items-center gap-1">
                    Subscribed <UserCheck size={16} />
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Withdraw Modal */}
      <div
        className={`fixed inset-0 z-50 bg-black/50  transition-opacity duration-300 ${
          showModal ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setShowModal(false)}
      >
        <div
          className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl p-6 transition-transform duration-300 ${
            showModal ? "translate-y-0" : "translate-y-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Withdraw Funds</h2>
            <button onClick={() => setShowModal(false)}>
              <X className="text-gray-600" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Enter Amount to Withdraw</label>
              <input
                type="number"
                placeholder="₦0.00"
                className="mt-1 w-full border border-gray-200 rounded-xl p-3"
                min={5000}
              />
            </div>

            <div className="bg-gray-100 rounded-xl p-4">
              <p className="font-semibold">
                {user?.user?.withdrawalBankName}
              </p>
              <p className="text-gray-500 text-sm">
                {user?.user?.withdrawalBankAccountNumber}
              </p>
            </div>

            <div className="flex justify-between mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="text-red-500 font-medium"
              >
                Cancel
              </button>
              <button 
                className="bg-green-400 text-black px-6 py-2 rounded-xl font-semibold" 
                disabled={false}
                onClick={handleWithdrawal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <BottomNavbar />
    </div>
  );
}
